import { type FC, useState } from 'react';
import { BsFileEarmarkPlus } from 'react-icons/bs';
import { Button } from 'react-bootstrap';

import AddPageModal from '@editor2/components/AddPageModal';
import { toolsBlock } from '@editor2/containers/PageGroupPage/styles';

interface Props {
	pageGroupId: string;
	courseId: number;
}

const Tools: FC<Props> = (props) => {
	const { pageGroupId, courseId } = props;
	const [isAddPageModalShown, setAddPageModalShown] = useState(false);

	return (
		<>
			<div className={toolsBlock}>
				<Button variant="outline-secondary" onClick={() => setAddPageModalShown(true)}>
					<BsFileEarmarkPlus />
					Add page
				</Button>
			</div>

			{isAddPageModalShown && (
				<AddPageModal
					pageGroupId={pageGroupId}
					onHide={() => setAddPageModalShown(false)}
					isShown={isAddPageModalShown}
					courseId={courseId}
				/>
			)}
		</>
	);
};

export default Tools;
